var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createElement, memo, useCallback, useEffect, useRef, useState } from '@max/max';
import View from '@hfe/max-view';
import CurrentPosition from './CurrentPosition/CurrentPosition';
import './CitySelection.scss';
import SearchArea from './SearchArea/SearchArea';
import CityList from './CityList/CityList';
import ScrollView from '@hfe/max-scrollview';
import { Actions } from '../../store';
import { getCityList } from '../../utils/CityUtils';
import { setStorage } from '@max/meituan-uni-storage';
const isMRN = false;
const isWeb = true;
import { screenHeight, reverseRem, statusBarHeight, isAndroid } from '../../utils/utils';
import { LX_CONFIG } from '../../constants';
function CitySelection(props) {
    const scrollViewRef = useRef(null);
    const [isSuggestArea, setIsSuggestArea] = useState(false);
    const [currentLetter, setCurrentLetter] = useState('');
    const [positions, setPositions] = useState();
    const reachEnd = useCallback(() => { }, []);
    const { dispatchCity, cityDataSourceState, _LXReport, _moduleId } = props || {};
    const mountedRef = useRef(true);
    useEffect(() => {
        mountedRef.current = true;
        getCityList().then(cityList => {
            if (mountedRef.current) {
                // 只在组件挂载时更新状态
                dispatchCity === null || dispatchCity === void 0 ? void 0 : dispatchCity(cityList);
            }
        });
        return () => {
            mountedRef.current = false; // 组件卸载时设置为 false
        };
    }, []);
    const letters = cityDataSourceState.map(item => item.label);
    const scrollTo = (pos) => {
        scrollViewRef && scrollViewRef.current && scrollViewRef.current.scrollTo({
            y: pos,
            animated: true,
            duration: 100
        });
    };
    const receiveLetter = useCallback((letter) => {
        // console.log('current letter', letter);
        setCurrentLetter(letter);
    }, []);
    const receivePositions = useCallback((pp) => {
        setPositions(pp);
    }, []);
    const updateRecentCityStorage = (item) => __awaiter(this, void 0, void 0, function* () {
        if (!mountedRef.current)
            return; // 添加卸载检查
        const result = (props.cityRecent || []).slice(0);
        // 判断是不是之前有的城市
        const indexOld = result.findIndex(originalItem => item.id === originalItem.id);
        if (indexOld >= 0) {
            result.splice(indexOld, 1);
        }
        else if ((result === null || result === void 0 ? void 0 : result.length) > 4) {
            result.pop();
        }
        // console.log('updateRecentCityStorage', result);
        result.unshift(item);
        props.dispatchEvent && props.dispatchEvent({
            type: Actions.updateRecentCity,
            data: result
        });
        setStorage({
            key: 'hotelPoilistCitySelection__recentcities',
            data: result
        });
    });
    const receiveCity = useCallback((city, isReport = false) => {
        var _a;
        if (!mountedRef.current)
            return; // 添加卸载检查
        props.dispatchEvent && props.dispatchEvent({
            type: Actions.updateCitySelection,
            data: {
                label: city.name,
                value: city.id
            }
        });
        (_a = props === null || props === void 0 ? void 0 : props._communication) === null || _a === void 0 ? void 0 : _a.emit('poiCityChanged', city);
        // console.log('触发事件poiCityChanged', city)
        props.dispatchEvent && props.dispatchEvent({
            type: Actions.toggleCitySelection
        });
        updateRecentCityStorage(city);
        if (isReport) {
            _LXReport === null || _LXReport === void 0 ? void 0 : _LXReport.mcReport(LX_CONFIG.CITY_MC_BID, {
                valLab: {
                    _moduleId,
                    city_id: city.id,
                    city_name: city.name
                }
            });
        }
    }, [props.dispatchEvent]);
    useEffect(() => {
        if (currentLetter && currentLetter.length > 0) {
            const index = letters.indexOf(currentLetter);
            (positions === null || positions === void 0 ? void 0 : positions[index]) && scrollTo(positions[index]);
        }
    }, [currentLetter, positions]);
    const emitCloseEventCallback = useCallback(() => {
        props.dispatchEvent && props.dispatchEvent({
            type: Actions.toggleCitySelection,
            data: false
        });
    }, []);
    const emitSearchValueChangeCallback = useCallback((value) => {
        if (value !== '') {
            setIsSuggestArea(true);
        }
        else {
            setIsSuggestArea(false);
        }
    }, []);
    const iosHeight = (screenHeight - statusBarHeight) * 0.6;
    const height = isWeb ? isAndroid ? '60vh' : `${iosHeight}px` : reverseRem(iosHeight);
    return <View style={{
        height
    }}>
      <SearchArea emitCloseEvent={emitCloseEventCallback} emitSearchValueChange={emitSearchValueChangeCallback} allStates={props.allStates} dispatchEvent={props.dispatchEvent}/>
      <View x-if={!isSuggestArea}>
        <ScrollView showsVerticalScrollIndicator={false} refreshType={'system'} ref={scrollViewRef} className={'city-selection-scroll-view-main'} style={{
        height: isMRN ? '100%' : '100vh'
    }} disableScroll={false} onEndReached={reachEnd} onEndReachedThreshold={100}>
          <CurrentPosition emitCity={receiveCity} dispatchEvent={props.dispatchEvent} locationCity={props.locationCity}/>
          
          <CityList cityDataSource={cityDataSourceState} letters={letters} emitCity={city => receiveCity(city, true)} currentLetter={currentLetter} emitPositions={receivePositions}/>
          <View x-if={!isAndroid} className="city-selection-margin"/>
        </ScrollView>
        
      </View>
    </View>;
}
export default memo(CitySelection);
